import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LaundryRecDetailApi } from '../api/laundryrecdetail.api';
import { switchMap, map } from 'rxjs/operators';

import { LaundryRecDetailData, LaundryRecDetail, DashboardList } from '../../../interfaces/masters/laundryrecdetail' ;
@Injectable()
export class LaundryRecDetailService extends LaundryRecDetailData {

    constructor(private api: LaundryRecDetailApi) {
      super();
    }
  
  
    list(url: string): Observable<LaundryRecDetail[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LaundryRecDetail[]>{
      debugger;
        return this.api.getById(url);
    }
    listReceivedBy(url:string):Observable<any> {
      
      return this.api.listReceivedBy(url);
    }
     dashboardList(url: string): Observable< DashboardList[]> {
      return this.api.dashboardList(url);
    }
  
    create(url: string, data:LaundryRecDetail[]): Observable<LaundryRecDetail> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:LaundryRecDetail): Observable<LaundryRecDetail> {
      debugger;
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }